import React, { Component } from 'react';
import {
    Form,
    Button,
    Card,
    Alert,
    Row,
    Col,
    Badge,
} from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import {
    FaWallet,
    FaPiggyBank,
    FaCreditCard,
    FaHome,
    FaChartLine,
    FaSave,
    FaTimes,
    FaTrash,
    FaEdit,
    FaInfoCircle
} from 'react-icons/fa';
import './CreateAssetForm.css';
import ModernConfirmModal from './ModernConfirmModal';

class CreateAssetForm extends Component {
    bookId = JSON.parse(localStorage.bookId);

    constructor(props) {
        super(props);
        this.state = {
            assetId: props.data?.asset_id || '',
            bookId: this.bookId,
            name: props.data?.name || '',
            desc: props.data?.desc || '',
            type: props.data?.type || '',
            amount: props.data?.finalAmount || 0,
            category: props.data?.category || '',
            validated: false,
            active: props.data?.active !== undefined ? props.data.active : '1',
            edit: props.edit || false,
            amountBefore: props.data?.finalAmount || 0,
            tAmount: 0,
            loading: false,
            error: null,
            success: false,
            showDeleteConfirm: false,
            deleteLoading: false, 
        }
    }

    categoryOptions = {
        '1': [ // Aset
            { value: '1', label: 'Aset Lancar', icon: FaWallet, description: 'Kas, tabungan, deposito' },
            { value: '2', label: 'Aset Tetap', icon: FaHome, description: 'Properti, kendaraan, equipment' },
            { value: '3', label: 'Aset Investasi', icon: FaChartLine, description: 'Saham, reksadana, obligasi' }
        ],
        '2': [ // Kewajiban
            { value: '4', label: 'Hutang Jangka Pendek', icon: FaCreditCard, description: 'Kartu kredit, hutang usaha' },
            { value: '5', label: 'Hutang Jangka Panjang', icon: FaPiggyBank, description: 'KPR, pinjaman bank' }
        ]
    }

    getTypeLabel = (type) => {
        return type === '1' ? 'Aset' : 'Kewajiban';
    }

    getTypeColor = (type) => {
        return type === '1' ? 'success' : 'warning';
    }

    getCategoryIcon = (categoryValue) => {
        const allCategories = [...this.categoryOptions['1'], ...this.categoryOptions['2']];
        const category = allCategories.find(cat => cat.value === categoryValue);
        return category ? category.icon : FaWallet;
    }

    hitungAmount = (value) => {
        const newAmount = parseFloat(value) || 0;
        const amountBefore = parseFloat(this.state.amountBefore) || 0;
        const tAmount = newAmount - amountBefore;
        
        this.setState({ 
            amount: newAmount,
            tAmount: tAmount
        });
    }

    validateForm = () => {
        const { name, desc, type, category, amount } = this.state;
        return name && desc && type && category;
    }
    deleteAsset = async (e) => {
        this.setState({ 
            showDeleteConfirm: true,
            deleteLoading: false 
        });
    }
    /*
    deleteAsset = async (e) => {
        try{
            if(window.confirm("Anda akan menghapus aset "+ this.state.name)){
                await this.props.deleteAsset(this.state.assetId)
                this.setState({ success: true });
                setTimeout(() => {
                    this.props.handleClose();
                }, 1500);
            }
        } catch (error) {
            console.error("Error deleting asset:", error);
            this.setState({ 
                error: "Gagal menghapus data. Silakan coba lagi.", 
                loading: false 
            });
        }
        

    }
        */
    confirmDelete = async () => {
        this.setState({ deleteLoading: true });
        
        try {
            await this.props.deleteAsset(this.state.assetId);
            this.setState({ 
            success: true, 
            showDeleteConfirm: false,
            deleteLoading: false 
            });
            
            setTimeout(() => {
            this.props.handleClose();
            }, 1500);
            
        } catch (error) {
            console.error("Error deleting asset:", error);
            this.setState({ 
            error: "Gagal menghapus data. Silakan coba lagi.", 
            deleteLoading: false,
            showDeleteConfirm: false
            });
        }
    }
    cancelDelete = () => {
        this.setState({ 
            showDeleteConfirm: false,
            deleteLoading: false 
        });
    }

    saveAsset = async (e) => {
        e.preventDefault();
        
        if (!this.validateForm()) {
            this.setState({ 
                validated: true, 
                error: "Harap lengkapi semua field yang wajib diisi. Jumlah harus lebih besar dari 0" 
            });
            return;
        }

        this.setState({ loading: true, error: null, success: false });

        try {
            if (this.state.edit) {
                // Update existing asset
                var amt
                if(this.state.category == 1 && this.state.type == 1){
                    amt = this.state.amountBefore
                }else{
                    amt = this.state.amount
                    //selain aset lancar
                    await this.props.updateAsset({
                    assetId: this.state.assetId,
                    bookId: this.state.bookId,
                    name: this.state.name,
                    desc: this.state.desc,
                    amount: amt,
                    active: this.state.active,
                });
                }
                /*
                await this.props.updateAsset({
                    assetId: this.state.assetId,
                    bookId: this.state.bookId,
                    name: this.state.name,
                    desc: this.state.desc,
                    amount: amt,
                    active: this.state.active,
                });
                */

                // Handle amount adjustment
                if (this.state.tAmount !== 0 && this.state.category == 1 && this.state.type == 1) {
                    const shouldCreateAdjustment = window.confirm(
                        `Selisih Rp ${this.state.tAmount.toLocaleString('id-ID')} akan dimasukkan dalam transaksi sebagai 'Penyesuaian Aset'. Lanjutkan?`
                    );

                    if (shouldCreateAdjustment) {
                        await this.props.createTransaction({
                            assetId: this.state.assetId,
                            bookId: this.state.bookId,
                            desc: "Penyesuaian aset",
                            categoryId: 0,
                            amount: this.state.tAmount,
                            transactionDate: new Date(),
                        });
                    }
                }
            } else {
                // Create new asset
                await this.props.createAsset(this.state);
            }

            this.setState({ success: true });
            setTimeout(() => {
                this.props.handleClose();
            }, 1500);

        } catch (error) {
            console.error("Error saving asset:", error);
            this.setState({ 
                error: "Gagal menyimpan data. Silakan coba lagi.", 
                loading: false 
            });
        }
    }

    renderCategoryOptions = () => {
        const { type } = this.state;
        const options = this.categoryOptions[type] || [];

        return (
            <Form.Group className="mb-3">
                <Form.Label className="form-label">
                    <FaInfoCircle className="me-2" />
                    Kategori
                </Form.Label>
                <Form.Select 
                    value={this.state.category} 
                    onChange={(e) => this.setState({ category: e.target.value })} 
                    disabled={this.state.edit}
                    required
                    className="modern-select"
                >
                    <option value="">Pilih Kategori</option>
                    {options.map((option) => {
                        const IconComponent = option.icon;
                        return (
                            <option key={option.value} value={option.value}>
                                {option.label} - {option.description}
                            </option>
                        );
                    })}
                </Form.Select>
            </Form.Group>
        );
    }

    renderCategoryCards = () => {
        const { type } = this.state;
        const options = this.categoryOptions[type] || [];

        if (this.state.edit) return this.renderCategoryOptions();

        return (
            <Form.Group className="mb-3">
                <Form.Label className="form-label">
                    <FaInfoCircle className="me-2" />
                    Pilih Kategori
                </Form.Label>
                <Row>
                    {options.map((option) => {
                        const IconComponent = option.icon;
                        const isSelected = this.state.category === option.value;
                        
                        return (
                            <Col md={6} key={option.value} className="mb-2">
                                <div 
                                    className={`category-card ${isSelected ? 'selected' : ''}`}
                                    onClick={() => this.setState({ category: option.value })}
                                >
                                    <div className="category-icon">
                                        <IconComponent />
                                    </div>
                                    <div className="category-content">
                                        <h6>{option.label}</h6>
                                        <small>{option.description}</small>
                                    </div>
                                    <div className="category-check">
                                        {isSelected && <div className="checkmark">✓</div>}
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </Form.Group>
        );
    }

    render() {
        const isEditing = this.state.edit;
        const hasAmountChange = this.state.tAmount !== 0;

        return (
            <div className="create-asset-form-modern">
                <ModernConfirmModal
                    show={this.state.showDeleteConfirm}
                    onHide={this.cancelDelete}
                    onConfirm={this.confirmDelete}
                    title="Hapus Aset/Kewajiban"
                    message="Apakah Anda yakin ingin menghapus item ini secara permanent?"
                    itemName={this.state.name}
                    confirmText="Ya, Hapus Permanent"
                    loading={this.state.deleteLoading}
                    stripColor="#dc3545"
                    stripHeight="6px"
                />
                <Card className="asset-form-card">
                    <Card.Header className="asset-form-header">
                        <div className="d-flex align-items-center">
                            <div className="header-icon">
                                {isEditing ? <FaEdit /> : <FaWallet />}
                            </div>
                            <div>
                                <h4 className="mb-0">
                                    {isEditing ? 'Edit Aset/Kewajiban' : 'Tambah Baru'}
                                </h4>
                                <Badge 
                                    bg={this.getTypeColor(this.state.type)} 
                                    className="mt-1 type-badge"
                                >
                                    {this.getTypeLabel(this.state.type)}
                                </Badge>
                            </div>
                        </div>
                    </Card.Header>

                    <Card.Body>
                        {this.state.error && (
                            <Alert variant="danger" dismissible onClose={() => this.setState({ error: null })}>
                                {this.state.error}
                            </Alert>
                        )}

                        {this.state.success && (
                            <Alert variant="success">
                                {isEditing ? 'Data berhasil diperbarui!' : 'Aset/Kewajiban berhasil dibuat!'}
                            </Alert>
                        )}

                        {hasAmountChange && isEditing && (
                            <Alert variant="info" className="amount-change-alert">
                                <strong>Perubahan jumlah terdeteksi:</strong><br />
                                Selisih: Rp {this.state.tAmount.toLocaleString('id-ID')}
                            </Alert>
                        )}

                        <Form 
                            id="createAssetForm" 
                            validated={this.state.validated}  
                            onSubmit={this.saveAsset}
                            className="asset-form"
                        >
                            <Row>
                                <Col md={8}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            Nama Item
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={this.state.name}
                                            onChange={(e) => this.setState({ name: e.target.value })}
                                            placeholder="Contoh: Tabungan Bank ABC, KPR Rumah, dll."
                                            required
                                            className="modern-input"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            Tipe
                                        </Form.Label>
                                        <Form.Select 
                                            value={this.state.type} 
                                            onChange={(e) => this.setState({ 
                                                type: e.target.value,
                                                category: '' // Reset category when type changes
                                            })} 
                                            disabled={isEditing}
                                            required
                                            className="modern-select"
                                        >
                                            <option value="">Pilih Tipe</option>
                                            <option value="1">Aset</option>
                                            <option value="2">Kewajiban</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="mb-3">
                                <Form.Label className="form-label">
                                    Deskripsi
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={this.state.desc}
                                    onChange={(e) => this.setState({ desc: e.target.value })}
                                    placeholder="Deskripsi detail tentang item ini..."
                                    required
                                    className="modern-textarea"
                                />
                            </Form.Group>

                            {this.state.type && this.renderCategoryCards()}

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-label">
                                            Jumlah Nilai
                                        </Form.Label>
                                        <CurrencyInput
                                            className="form-control modern-currency-input"
                                            placeholder="Masukkan jumlah nilai"
                                            defaultValue={this.state.amount}
                                            decimalsLimit={2}
                                            intlConfig={{ locale: 'id-ID', currency: 'IDR' }}
                                            onValueChange={(value) => this.hitungAmount(value)}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    {isEditing && (
                                        <Form.Group className="mb-3">
                                            <Form.Label className="form-label">
                                                Status
                                            </Form.Label>
                                            <div className="switch-container">
                                                <div className="switch-label">
                                                    <span>Akun {this.state.active === '1' ? 'Aktif' : 'Non-Aktif'}</span>
                                                </div>
                                                <Form.Check
                                                    checked={this.state.active === '1'}
                                                    onChange={(e) => this.setState({ active: e.target.checked ? '1' : '0' })}
                                                    className="modern-switch"
                                                />
                                            </div>
                                        </Form.Group>
                                    )}
                                </Col>
                            </Row>

                            <div className="form-actions">
                                <Button
                                    variant="outline-secondary"
                                    onClick={this.props.handleClose}
                                    className="action-btn"
                                    disabled={this.state.loading}
                                >
                                    <FaTimes className="me-2" />
                                    Batal
                                </Button>
                                {isEditing && this.state.category != 1 && (
                                <Button
                                    variant="danger"
                                    onClick={this.deleteAsset}
                                    className="action-btn"
                                    disabled={this.state.loading || this.state.deleteLoading}
                                >
                                    <FaTrash className="me-2" />
                                    Hapus
                                </Button>
                                )}
                                <Button
                                    type="submit"
                                    variant="primary"
                                    disabled={this.state.loading}
                                    className="action-btn submit-btn"
                                >
                                    {this.state.loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            Menyimpan...
                                        </>
                                    ) : (
                                        <>
                                            <FaSave className="me-2" />
                                            {isEditing ? 'Perbarui Data' : 'Simpan Item'}
                                        </>
                                    )}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default CreateAssetForm;